import { CommandType } from "~app/common/services/cqs/CommandType";
import { ProduktionsmallProduktinstruktionBaseCommand } from "./ProduktionsmallProduktinstruktionBaseCommand";

export class DeleteProduktionsmallProduktinstruktionCommand extends ProduktionsmallProduktinstruktionBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DeleteProduktionsmallProduktinstruktionCommand";

    constructor(produktionsmallGuid: string, handelssortimentId: number, produktId: number, produktinstruktionId: number) {
        super(DeleteProduktionsmallProduktinstruktionCommand.$type, CommandType.Delete);
        this.produktionsmallGuid = produktionsmallGuid;
        this.handelssortimentId = handelssortimentId;
        this.produktId = produktId;
        this.produktinstruktionId = produktinstruktionId;
    }
}
